export default "__VITE_ASSET__7cce0714__"